import React, { useState } from 'react';

import { FormContainer } from '../../styled';
import { fetchApiData } from '../../Utils/ApiCalls';
import { REQUEST_STATUS_ENUM } from '../../Constants/Constants';
import { PUT_REQUEST_ON_HOLD, RESUME_ON_HOLD_REQUEST } from '../../urls';
import { Button, Input, RadioGroup, showToast } from '@attentive-platform/stem-ui';

const RequestOnHold = () => {
  const [requestId, setRequestId] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [status, setStatus] = useState(REQUEST_STATUS_ENUM.ON_HOLD);

  const handleSubmit = async () => {
    if (!requestId.trim()) {
      showToast('Please enter a request ID', 'error');
      return;
    }

    setIsLoading(true);
    try {
      const data = {
        request_id: requestId.trim()
      };

      const endpoint = status === REQUEST_STATUS_ENUM.ON_HOLD ? PUT_REQUEST_ON_HOLD : RESUME_ON_HOLD_REQUEST;
      const response = await fetchApiData({
        data,
        endpoint: endpoint,
        apiRequest: 'POST'
      });

      if (response.error) {
        showToast(response.error, 'error');
      } else {
        setRequestId('');
        showToast(response.data.message, 'success');
        setStatus(REQUEST_STATUS_ENUM.ON_HOLD);
      }
    } catch (error) {
      showToast(error, 'error');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <FormContainer>
      <div className='border border-gray-200 rounded-lg p-6 bg-white'>
        <div className='space-y-6'>
          <div>
            <label className='block text-sm font-medium text-gray-700 mb-2'>Request ID</label>
            <Input
              type='text'
              value={requestId}
              className='w-full'
              placeholder='Enter request ID'
              onChange={e => setRequestId(e.target.value)}
            />
          </div>

          <div>
            <label className='block text-sm font-medium text-gray-700 mb-3'>Status</label>
            <RadioGroup
              value={status}
              variant='standard'
              radioGroup={[
                {
                  label: 'On hold',
                  value: REQUEST_STATUS_ENUM.ON_HOLD
                },
                {
                  label: 'In progress',
                  value: REQUEST_STATUS_ENUM.IN_PROGRESS
                }
              ]}
              onChange={(event, newValue) => setStatus(newValue)}
            />
          </div>

          <Button onClick={handleSubmit} disabled={isLoading || !requestId.trim()} className='w-full'>
            Update request status
          </Button>
        </div>
      </div>
    </FormContainer>
  );
};

export default RequestOnHold;
